<template>
  <div>
    <template v-if="dataList.length">
		<van-list
			v-model="loading"	
			:finished="finished"
			:immediate-check="false"
			finished-text="没有更多了"
			@load="onLoad"
			:offset="10"
		>
			<div class="lineList">
				<div class="line flex flex-align-center" v-for="item in dataList" :key="item.id" @click="$router.push({name: 'my_homePage', query: {id: item.id}})">
					<img :src="item.avatar" class="avatar" />
					<div class="line-info flex flex-column">
						<div class="flex flex-align-center">
							<div class="name">{{item.nickname}}</div>
							<div>
								<img v-if="item.is_vip == 1" src="@/static/images/my/memberIDF.png" class="memberIDF1" />
								<img v-if="item.is_teacher_certification == 1" src="@/static/images/index/certImg2.png" class="memberIDF1" />
								<img v-if="item.is_examiner_certification == 1" src="@/static/images/index/certImg3.png" class="memberIDF1" />
							</div>
						</div>
						<div class="tips">{{item.is_vip == 1? '福建省民族管弦乐会员' : '非会员'}}</div>
					</div>
				</div>
			</div>
		</van-list>
		</template>
		<template v-else>
			<div class="empty">
				<div class="empty-img">
					<img src="@/static/images/index/emptySearch.png" alt="">
				</div>
				<div class="empty-text">暂无数据</div>
			</div>
		</template>
  </div>
</template>

<script>
export default {
	data() {
		return {
			pageSize: 15,
			page: 1,
			loading: false,
      finished: false,
      dataList: []
		};
	},
	props: {
    search_text: {
      type: String,
      default: ''
    }
  },
	methods: {
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
		getList() {
			this.$get('api/index/search', {
				type: 6,
				pageSize: this.pageSize,
				page: this.page,
				search_text: this.search_text
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
				this.dataList.splice((this.page - 1) * 10, 10, ...rows)

			})
		}
	}
};
</script>

<style scoped lang="stylus">
.lineList
	padding 0 30px
	.line
		.avatar
			width 72px
			height 72px
			margin-right 24px
			border-radius 50%
			overflow hidden
		.line-info
			width 592px
			border-bottom 2px solid #E3E3E3
			padding 24px 0
			.name
				font-size 26px
				color #000000
			.memberIDF1
				width 32px
				height 32px
				margin-left 12px
			.tips
				margin-top 12px
				font-size 22px
				color #818181
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
